import { isNotPwned } from "@/shared/passwordChecker";

const validate = (value: string) => {
  const errorMessage = checkForbiddenPhrases(value);

  if (errorMessage) {
    return Promise.reject<boolean>({ message: errorMessage });
  }

  return isNotPwned(value);
};

const forbiddenPhrases = ["hsabank", "password"];

const checkForbiddenPhrases = (value: string) => {
  if (!value) {
    return "";
  }

  const passwordLower = value.toLowerCase();
  const foundPhrase = forbiddenPhrases.find(phrase => passwordLower.includes(phrase));

  if (foundPhrase) {
    return `This password contains the phrase "${foundPhrase}", which makes it easy to guess.`;
  }

  return "";
};

export default {
  validate
};
